<template>
  <div>
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <h3>ตารางรายละเอียดติดตั้งแต่ละจุด</h3>
      </b-col>
      <b-col
        lg="4"
        md="4"
        class="d-flex align-items-center justify-content-start mb-1"
      >
        <label>ค้นหา</label>
        <b-input-group
          size="sm"
          style="padding-left:14px;"
        >
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="ป้อนคำค้นหา"
            label-cols-sm="12"
            label-cols-md="2"
            label-cols-lg="2"
            style=" background-color:rgba(0,0,0, 0.6);"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              ล้าง
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="12">
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          style="background-color:rgba(0, 22, 45, 0.1);"
          @filtered="onFiltered"
        >
          <template
            #cell(id)="data"
          >
            <b-link
              v-b-modal="'modalEdit'"
              @click="$refs.refEdit.editModal(data.item.devid)"
            ><b-img
              src="@/assets/images/icons/Edit.svg"
            />
            </b-link>
            <!-- <b-link
              @click.prevent="remove(data.item.id)"
            >
              <b-img
                src="@/assets/images/icons/Delete.svg"
              />
            </b-link> -->
          </template>
          <template #cell(devid)="data">
            <b-link
              v-b-modal="'Log'"
              style="text-decoration: underline; color:chocolate;"
              @click="$refs.childref.getTableLog(data.item.devid)"
            >
              <span v-if="data.item.deveui != null">
                {{ data.item.deveui }}
              </span>
              <span v-if="data.item.deveui == null">
                {{ data.item.devid }}
              </span>
            </b-link>

          </template>
          <template #cell(devstatus)="data">
            <b-badge
              :variant="devstatus[1][data.value]"
              style="font-size: 13px;"
            >
              {{ devstatus[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(devstate)="data">
            <b-img
              v-if="data.item.devstatus == 'ดับ'"
              :src="require('@/assets/images/icons/lighting_icon_map1.png')"
              height="16"
            />
            <b-img
              v-if="data.item.devstatus == 'ปกติ'"
              :src="require('@/assets/images/icons/lighting_icon_map.png')"
              height="16"
            />
          </template>
          <template #cell(devconnect)="data">
            <b-badge
              :variant="status[1][data.value]"
              style="font-size: 13px;"
            >
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>
      </b-col>
      <b-col
        cols="12"
      >
        <b-card-body class="d-flex justify-content-between flex-wrap pt-1">
          <!-- page length -->
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
            />
          </b-form-group>

          <!-- pagination -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-col>
    </b-row>
    <!-- MODAL EDIT -->
    <ModalEditNetvox
      ref="refEdit"
      @fetch="getSemDetail()"
    />
    <modalLog
      ref="childref"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BPagination, BInputGroup, BInputGroupAppend, BFormInput, BButton,
  BFormGroup, BFormSelect, BCardBody, BLink, BImg, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import ModalEditNetvox from './NetvoxEdit.vue'
import modalLog from './modalLog.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BButton,
    BFormGroup,
    BFormSelect,
    BCardBody,
    BLink,
    BImg,
    BBadge,
    ModalEditNetvox,
    modalLog,
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'pole', label: 'เสาไฟ', class: 'text-center' },
        {
          key: 'devct', label: 'กระแสไฟฟ้า', sortable: true, class: 'text-center', thStyle: { background: 'rgb(255, 177, 0,0.7)' }, tdClass: 'bg-light-warning',
        },
        {
          key: 'devstatus', label: 'การทำงาน', sortable: true, class: 'text-center',
        },
        {
          key: 'devstate', label: 'สถานะ', sortable: true, class: 'text-center',
        },
        {
          key: 'devid', label: 'รหัสอุปกรณ์', sortable: true, class: 'text-center',
        },
        {
          key: 'devbattery', label: 'แบตเตอรี่', sortable: true, class: 'text-center',
        },
        {
          key: 'lastupdate', label: 'อัพเดทล่าสุด', sortable: true, class: 'text-center',
        },
        {
          key: 'devconnect', label: 'การเชื่อมต่อ', sortable: true, class: 'text-center',
        },
        { key: 'id', label: 'การจัดการ', class: 'text-center' },
      ],
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: '',
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: [{
        ติดต่อไม่ได้: 'ติดต่อไม่ได้', ปกติ: 'ปกติ',
      },
      {
        ติดต่อไม่ได้: 'light-danger', ปกติ: 'light-success',
      }],
      devstatus: [{
        ดับ: 'ไฟดับ', ปกติ: 'ปกติ',
      },
      {
        ดับ: 'light-danger', ปกติ: 'light-success',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fieldsSpeaker
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSemDetail()
    this.interval = setInterval(() => {
      this.getSemDetail()
    }, 300000)
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handle(event) {
      console.log('Event received:', event)
    },
    getSemDetail() {
      axios
        .post('/getMarkerSEM', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
